<template>
  <Modal v-model="modifyWaybillNumberModal" :title="$t('key1004642')" :transfer="false" :mask-closable="false"
    @on-visible-change="modifyWaybillNumberChange">
    <Form ref="modifyWaybillNumberForm" :model="modifyWaybillNumberForm" :label-width="90" :rules="ruleValidate" @submit.native.prevent>
      <Row style="width: 80%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004643')" prop="shippingMethodId">
            <Select v-model="modifyWaybillNumberForm.shippingMethodId" filterable>
              <Option v-for="item in shippingMethodIdList" :key="item.shippingMethodId"
                :value="item.shippingMethodId">{{ item.carrierShippingMethodName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001521')" prop="trackingNumber">
            <Input v-model="modifyWaybillNumberForm.trackingNumber" :placeholder="$t('key1004644')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004394')" prop="thirdPartyNo">
            <Input v-model="modifyWaybillNumberForm.thirdPartyNo" :placeholder="$t('key1004645')"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="modifyWaybillNumberModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="modifyWaybillNumberBtn">{{ $t('key1004286') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "modifyWaybillNumberModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      modifyWaybillNumberModal: false,
      modifyWaybillNumberForm: {
        distributorMerchantId: null,
        packageCode: null, // 云卖订单号
        shippingMethodId: null, // 物流方式
        thirdPartyNo: null, // 物流商单号
        trackingNumber: null, // 运单号
        ymsPackageId: null
      },
      ruleValidate: {
        shippingMethodId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004640'), trigger: 'change'}
        ],
        trackingNumber: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004641'), trigger: 'blur'}
        ],
      },
      shippingMethodIdList: [],
      carrierId: null
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initModifyWaybillNumberData(data) {
      let {shippingMethodId, ...obj} = this.modifyWaybillNumberForm;
      for (let key in obj) {
        this.modifyWaybillNumberForm[key] = data[key];
      }
      this.carrierId = data.carrierId;
      this.getshippingMethodData(data);
      this.modifyWaybillNumberModal = true;
    },
    // 获取对应物流商下已启用的物流渠道数据
    getshippingMethodData(obj) {
      let v = this;
      let params = `?carrierId=${obj.carrierId}&status=1`;
      v.axios.get(api.get_carrierShippingMethod_queryForEnableShippingMethods + params, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.shippingMethodIdList = data;
            let talg = data.some((item) => {
              return item.shippingMethodId === obj.shippingMethodId;
            });
            if (talg) {
              v.modifyWaybillNumberForm.shippingMethodId = obj.shippingMethodId;
            } else {
              v.modifyWaybillNumberForm.shippingMethodId = null;
            }
          }
        }
      });
    },
    // 确认修改
    modifyWaybillNumberBtn() {
      let v = this;
      v.$refs['modifyWaybillNumberForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsPackageInfo_modifyCarrierMessage, v.modifyWaybillNumberForm, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.modifyWaybillNumberModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    modifyWaybillNumberChange(value) {
      if (!value) {
        this.carrierId = null;
        this.shippingMethodIdList = [];
        this.$nextTick(() => {
          this.$refs['modifyWaybillNumberForm'].resetFields();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>